import React, {Component} from 'react';
import {connect} from "react-redux";

import PropTypes from 'prop-types';

import Button from "../partials/elements/Button";
import {withVFTranslation} from "../../util/withVFTranslation";

class ConfirmDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  componentDidMount() {
    const {modalProps} = this.props;

    if(!modalProps.callback){
      throw Error('Showing confirm without callback');
    }

    if(this.props.onRef){
      this.props.onRef(this)
    }
  }

  componentWillUnmount() {
    if(this.props.onRef){
      this.props.onRef(undefined)
    }
  }

  closeModal(result) {
    let {close} = this.props;
    close(result);
  }

  onEscapeKey(){
    let {modalProps} = this.props;
    let isCancellable = modalProps.isCancellable;
    if(isCancellable){
      this.closeModal(false);
    }
  }

  render() {
    let {modalProps, t} = this.props;

    let isCancellable = modalProps.isCancellable;
    let okText = modalProps.okBtn || t('OK');
    let cancelText = modalProps.cancelBtn || t('Cancel')

    return (
      <div className="modal-content">
        <div className="modal-header draggable-header">
          <h5 className="modal-title">{modalProps.title}</h5>
          {isCancellable &&
          <button type="button" className="close" onClick={this.closeModal.bind(this, false)} aria-label={t("Close")}>
            <i className="icon ion-ios-close-empty" />
          </button>
          }
        </div>
        <div className="modal-body">
          <p className="whitespace-prewrap">{modalProps.message}</p>
        </div>
        <div className="modal-footer">
          <Button className={'btn btn-secondary'} onClick={this.closeModal.bind(this, false)}>{cancelText}</Button>
          <Button className={'btn btn-primary'} onClick={this.closeModal.bind(this, true)}>{okText}</Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

ConfirmDialog.propTypes = {
  close : PropTypes.func.isRequired,
  onRef : PropTypes.func,
  modalProps : PropTypes.object.isRequired
}

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog));
